export default __webpack_public_path__ + "static/media/DogByte_Paw.87c0f27c.svg";